import React, { useState } from 'react';
import PricingCard from './PricingCard';
import '../subscription-plan.scss';
import { useNavigate } from 'react-router-dom';
import { axiosInstanceV2 } from '../../../services/axios';
import { toast } from 'react-toastify';

const PricingSection = ({ billing, setBilling, plans, hideFreePlan }) => {
	const navigate = useNavigate();

	// const [selectedPlan, setSelectedPlan] = useState(null);
	const [showModal, setShowModal] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleOpenFreeModal = (plan) => {
		// setSelectedPlan(plan);
		setShowModal(true);
	};

	const activateFreePlan = async () => {
		try {
			setLoading(true);

			const authToken = localStorage.getItem('authToken');

			const response = await axiosInstanceV2.get('/subscription/start-free', {
				headers: {
					Authorization: `Bearer ${authToken}`,
				},
			});

			if (response?.data?.success) {
				toast.success('Your Free Plan is Active');

				setShowModal(false);

				navigate('/organizationDetail');

				return;
			}

			if (response?.data?.message === 'Subscription already exists') {
				toast.info('Free plan already active.');

				setShowModal(false);

				setTimeout(() => {
					navigate('/organizationDetail');
				}, 300);

				return;
			}

			toast.error(response?.data?.message || 'Failed to activate free plan');
		} catch (error) {
			console.log(error);

			const errorMessage = error?.response?.data?.message;

			if (errorMessage === 'Subscription already exists') {
				toast.info('Free plan already active.');

				setShowModal(false);

				setTimeout(() => {
					navigate('/organizationDetail');
				}, 300);

				return;
			}

			toast.error(errorMessage || 'Failed to activate free plan');
		} finally {
			setLoading(false);
		}
	};

	const filteredPlans = hideFreePlan
		? plans?.filter((plan) => plan?.name?.toLowerCase() !== 'free')
		: plans;

	return (
		<>
			<div className="pricing-wrapper">
				<div className="billing-toggle">
					<button
						className={billing === 'monthly' ? 'active' : ''}
						onClick={() => setBilling('monthly')}
					>
						Monthly
					</button>

					<button
						className={billing === 'yearly' ? 'active' : ''}
						onClick={() => setBilling('yearly')}
					>
						Yearly
					</button>
				</div>

				<div className="pricing-grid">
					{filteredPlans?.map((plan, i) => (
						<PricingCard
							key={i}
							plan={plan}
							billing={billing}
							onOpenFreeModal={handleOpenFreeModal}
						/>
					))}
				</div>
			</div>

			{/* Modal */}
			{showModal && (
				<>
					<div
						className="modal fade show"
						style={{
							display: 'block',
							backgroundColor: 'rgba(0,0,0,0.5)',
						}}
					>
						<div className="modal-dialog modal-dialog-top">
							<div className="modal-content">
								<div className="modal-header">
									<h5 className="modal-title">Free Plan Activation</h5>

									<button
										type="button"
										className="btn-close"
										onClick={() => setShowModal(false)}
									/>
								</div>

								<div className="modal-body">
									<p className="fw-semibold mb-2">Your Free Plan is Ready 🎉</p>

									<p className="text-muted mb-0">
										You can now continue with the free plan and complete your organization setup.
									</p>

									{/* {selectedPlan?.name && (
										<div className="mt-3">
											<strong>Selected Plan:</strong> {selectedPlan?.name}
										</div>
									)} */}
								</div>

								<div className="modal-footer">
									<div className="d-flex justify-content-end align-items-center gap-3 w-100">
										<button
											type="button"
											className="btn-cancel"
											onClick={() => setShowModal(false)}
										>
											Cancel
										</button>

										<button
											type="button"
											className="btn-primary-modal"
											onClick={activateFreePlan}
											disabled={loading}
										>
											{loading ? 'Loading...' : 'Continue Setup'}
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</>
			)}
		</>
	);
};

export default PricingSection;
